import React from 'react';
import './quantia.css';

/**
 * Logo QUANTIA siguiendo el patrón del style guide:
 *   - "QUANT" en lime
 *   - "IA" en blanco (o negro en variante light)
 *   - "Licitator" como sub-producto separado por una línea fina
 *
 * Props:
 *  - size:      'md' (default) | 'lg'
 *  - variant:   'light' (sobre fondo oscuro, default) | 'dark' (sobre fondo claro)
 *  - product:   string del nombre de producto (default "Licitator").
 *               Se puede pasar null para ocultarlo.
 *  - onClick:   handler opcional (cursor pointer)
 */
const Logo = ({
  size = 'md',
  variant = 'light',
  product = 'Licitator',
  onClick,
  className = '',
  sx = {},
}) => {
  const interactive = typeof onClick === 'function';
  return (
    <span
      className={`qa-logo qa-logo--${variant} ${size === 'lg' ? 'qa-logo--lg' : ''} ${className}`}
      onClick={onClick}
      style={{
        cursor: interactive ? 'pointer' : 'default',
        ...sx,
      }}
      role={interactive ? 'button' : undefined}
      tabIndex={interactive ? 0 : undefined}
      onKeyDown={
        interactive
          ? (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClick(e);
              }
            }
          : undefined
      }
    >
      <span>
        <span className="qa-logo__quant">QUANT</span>
        <span className="qa-logo__ia">IA</span>
      </span>
      {product && <span className="qa-logo__product">{product}</span>}
    </span>
  );
};

export default Logo;
